import { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import { ContentSection } from '@/constants/tos';
import * as Typography from '@/components/shadcn/typography';
import Section from '@/components/tos/desktop/Section';

export interface Props {
  data: {
    title: string;
    sections: ContentSection[];
  };
  setCurrentContent: Dispatch<SetStateAction<string | null>>;
  page?: string;
}

const Content = ({ data, setCurrentContent, page }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const topRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (topRef.current) {
      topRef.current.scrollIntoView({
        block: 'center',
      });
    }
  }, [page]);

  return (
    <div
      className="no-scrollbar col-span-2 h-[calc(100svh-7rem)] overflow-auto"
      ref={ref}>
      <div className="py-4" ref={topRef}>
        <Typography.H4>{data.title}</Typography.H4>
      </div>
      {data.sections.map(section => (
        <Section
          section={section}
          setCurrentContent={setCurrentContent}
          key={section.title}
          root={ref}
        />
      ))}
    </div>
  );
};

export default Content;
